var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdamamBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 80",
    style: {
      enableBackground: "new 0 0 400 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#77CC00;}\r\n\t.st1{fill:#F4F7FA;}\r\n\t.st2{opacity:0.7;fill:#F4F7FA;enable-background:new    ;}\r\n\t.st3{fill:#929497;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 254.5,
    cy: 40.9,
    rx: 28.6,
    ry: 28.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.7,29.5h-22.3c-0.7,0-1.3-0.6-1.3-1.3v-0.6c0-0.7,0.6-1.3,1.3-1.3h22.3c0.7,0,1.3,0.6,1.3,1.3v0.6 C267,29,266.4,29.5,265.7,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.7,42.5h-22.3c-0.7,0-1.3-0.6-1.3-1.3v-0.5c0-0.7,0.6-1.3,1.3-1.3h22.3c0.7,0,1.3,0.6,1.3,1.3v0.5 C267,41.9,266.4,42.5,265.7,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.7,55.4h-22.3c-0.7,0-1.3-0.6-1.3-1.3v-0.6c0-0.7,0.6-1.3,1.3-1.3h22.3c0.7,0,1.3,0.6,1.3,1.3v0.6 C267,54.9,266.4,55.4,265.7,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.9,36h-6.4c-0.7,0-1.3-0.6-1.3-1.3v-0.5c0-0.7,0.6-1.3,1.3-1.3h6.4c0.7,0,1.3,0.6,1.3,1.3v0.5 C251.2,35.4,250.6,36,249.9,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.1,49h-6.5c-0.7,0-1.3-0.6-1.3-1.3v-0.6c0-0.7,0.6-1.3,1.3-1.3h6.5c0.7,0,1.3,0.6,1.3,1.3v0.6 C251.3,48.4,250.8,49,250.1,49z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.5,42.4v4.2h-2V35.2h4.4c1.3,0,2.3,0.3,3,1s1.1,1.5,1.1,2.6s-0.4,2-1.1,2.6s-1.8,0.9-3.1,0.9h-2.3V42.4z  M110.5,40.8h2.4c0.7,0,1.2-0.2,1.6-0.5s0.6-0.8,0.6-1.4c0-0.6-0.2-1.1-0.6-1.5s-0.9-0.6-1.5-0.6h-2.4L110.5,40.8L110.5,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129,41.2c0,1.1-0.2,2.1-0.6,2.9c-0.4,0.8-0.9,1.5-1.7,1.9c-0.7,0.5-1.5,0.7-2.5,0.7c-0.9,0-1.7-0.2-2.5-0.7 c-0.7-0.5-1.3-1.1-1.7-1.9c-0.4-0.8-0.6-1.8-0.6-2.9v-0.6c0-1.1,0.2-2.1,0.6-2.9c0.4-0.8,0.9-1.5,1.7-1.9c0.7-0.5,1.5-0.7,2.5-0.7 c0.9,0,1.7,0.2,2.5,0.7c0.7,0.4,1.3,1.1,1.7,1.9s0.6,1.8,0.6,2.9V41.2z M127,40.6c0-1.3-0.2-2.2-0.7-2.9s-1.2-1-2-1 c-0.9,0-1.5,0.3-2,1s-0.7,1.6-0.7,2.8v0.7c0,1.2,0.2,2.2,0.7,2.9s1.2,1,2,1c0.9,0,1.5-0.3,2-1s0.7-1.6,0.7-2.9V40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.1,43.8l1.8-8.6h2l-2.6,11.4h-1.9l-2.2-8.3l-2.2,8.3h-2l-2.6-11.4h2l1.8,8.5l2.2-8.5h1.7L141.1,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M154.1,41.5h-4.7V45h5.5v1.6h-7.4V35.2h7.4v1.6h-5.4V40h4.7v1.5H154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.9,42.2h-2.2v4.4h-2V35.2h4c1.3,0,2.3,0.3,3,0.9c0.7,0.6,1.1,1.4,1.1,2.6c0,0.8-0.2,1.4-0.6,1.9 c-0.4,0.5-0.9,0.9-1.5,1.2l2.6,4.7v0.1h-2.1L161.9,42.2z M159.7,40.6h2c0.7,0,1.2-0.2,1.6-0.5s0.6-0.8,0.6-1.4 c0-0.6-0.2-1.1-0.5-1.4c-0.3-0.3-0.9-0.5-1.6-0.5h-2.1V40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.5,41.5h-4.7V45h5.5v1.6h-7.4V35.2h7.4v1.6h-5.4V40h4.7v1.5H175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M179.1,46.6V35.2h3.4c1,0,1.9,0.2,2.7,0.7c0.8,0.4,1.4,1.1,1.8,1.9c0.4,0.8,0.6,1.8,0.6,2.8v0.6 c0,1.1-0.2,2-0.6,2.8s-1,1.4-1.8,1.9c-0.8,0.4-1.7,0.7-2.7,0.7C182.5,46.6,179.1,46.6,179.1,46.6z M181.1,36.8V45h1.3 c1,0,1.8-0.3,2.4-1s0.8-1.6,0.8-2.8v-0.6c0-1.2-0.3-2.2-0.8-2.8c-0.5-0.7-1.3-1-2.3-1C182.5,36.8,181.1,36.8,181.1,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M195.9,46.6V35.2h3.9c1.3,0,2.3,0.3,2.9,0.8s1,1.3,1,2.3c0,0.5-0.1,1-0.4,1.4s-0.7,0.7-1.2,1 c0.6,0.2,1.1,0.5,1.4,0.9s0.5,1,0.5,1.7c0,1.1-0.3,1.9-1,2.5s-1.7,0.9-2.9,0.9h-4.2V46.6z M197.9,40h1.9c0.6,0,1.1-0.1,1.4-0.4 c0.3-0.3,0.5-0.7,0.5-1.2c0-0.6-0.2-1-0.5-1.2s-0.8-0.4-1.5-0.4h-1.9V40H197.9z M197.9,41.5V45h2.2c0.6,0,1.1-0.2,1.5-0.5 c0.3-0.3,0.5-0.7,0.5-1.3c0-1.2-0.6-1.8-1.8-1.8L197.9,41.5L197.9,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.5,40.6l2.6-5.4h2.2l-3.8,7.2v4.2h-2v-4.2l-3.8-7.2h2.2L210.5,40.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdamamBadge);
export default __webpack_public_path__ + "static/media/Edamam_Badge.8e87d8275adcedc980669ac599d8cc26.svg";
export { ForwardRef as ReactComponent };